import { Subject, Observable } from 'rxjs'

class BackDrop {
  private _subject: Subject<boolean>

  constructor() {
    this._subject = new Subject()
  }

  emit(value: boolean): void {
    this._subject.next(value)
  }

  getValue(): Observable<boolean> {
    return this._subject.asObservable()
  }
}

const SingletonInstance = new BackDrop()
Object.freeze(SingletonInstance)

export default SingletonInstance
